import { Link } from 'react-router-dom';
import { PiEnvelopeDuotone, PiMapPinDuotone, PiPhoneDuotone, PiShieldWarningDuotone } from 'react-icons/pi';

import ContentPageLayout from 'components/ContentPageLayout';

export default function ImpresszumPage() {
    return (
        <ContentPageLayout
            title="Impresszum"
            subTitle="A Fürge Diák Iskolaszövetkezet hivatalos szolgáltatói és kapcsolattartási adatai."
            contentClassName="max-w-3xl"
        >
            <h2 className="content-section-title">Fürge Diák Iskolaszövetkezet</h2>

            <div className="grid gap-3 sm:grid-cols-2">
                <InfoItem icon={<PiMapPinDuotone />} label="Székhely" value="9700 Szombathely, Belsikátor 3. I/2" />
                <InfoItem icon={<PiPhoneDuotone />} label="Telefon" value={<a href="tel:+3612482010">+36 (1) 248-2010</a>} />
                <InfoItem icon={<PiPhoneDuotone />} label="Fax" value={<a href="tel:+3612482016">+36 (1) 248-2016</a>} />
                <InfoItem icon={<PiEnvelopeDuotone />} label="E-mail" value={<a href="mailto:info@furgediak.hu">info@furgediak.hu</a>} />
            </div>

            <dl className="mt-8 grid gap-x-8 gap-y-4 border-t border-neutral-200 pt-8 sm:grid-cols-2">
                <DataRow label="Jogi forma" value="Iskolaszövetkezet" />
                <DataRow label="Fő tevékenység" value="7320’08 Piac-, közvélemény-kutatás" />
                <DataRow label="Cégjegyzékszám" value="18-02-100565" />
                <DataRow label="Adatkezelés nyilvántartási száma" value="NAIH-78837/2014" />
            </dl>

            <Link
                to="/belso-visszaeles-bejelentes"
                className="content-card-link mt-8 flex items-center gap-3 rounded-2xl border border-red-100 bg-red-50 p-4 text-red-700 transition hover:-translate-y-0.5 hover:border-red-200 hover:bg-red-100 hover:shadow-md"
            >
                <PiShieldWarningDuotone className="size-7 shrink-0" />
                <strong className="font-display text-base font-black text-red-700 sm:text-lg">Belső visszaélés – Bejelentési rendszer</strong>
            </Link>

            <div className="mt-8 border-t border-neutral-200 pt-8 text-sm text-neutral-500">
                <p>A „FürgeDiák” elnevezés a Szabadalmi Hivatalnál védjegyként bejegyzésre került.</p>
                <p className="mt-3">Kérdés vagy vélemény esetén írj az <a href="mailto:info@furgediak.hu">info@furgediak.hu</a> címre.</p>
                <p className="mt-5 font-semibold text-neutral-700">Fürge Diák Iskolaszövetkezet 2024 © Minden jog fenntartva.</p>
            </div>
        </ContentPageLayout>
    );
}

function InfoItem({ icon, label, value }) {
    return (
        <div className="flex gap-3 rounded-2xl bg-neutral-50 p-4">
            <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-green-50 text-xl text-green-700">{icon}</span>
            <span>
                <span className="block text-xs font-bold uppercase tracking-wide text-neutral-400">{label}</span>
                <span className="mt-0.5 block text-sm font-semibold text-neutral-800">{value}</span>
            </span>
        </div>
    );
}

function DataRow({ label, value }) {
    return (
        <div>
            <dt className="text-xs font-bold uppercase tracking-wide text-neutral-400">{label}</dt>
            <dd className="mt-1 font-semibold text-neutral-800">{value}</dd>
        </div>
    );
}
